export default "__VITE_ASSET__CFcralmK__"